export enum ReleaseNoteAudience {
  Internal = "internal",
  Partners = "partners",
  Merchants = "merchants",
}

export enum ReleaseNoteLanguage {
  English = "en",
  Dutch = "nl",
  Italian = "it",
}

export enum ReleaseNotePublishStatus {
  Draft = "draft",
  Published = "published",
}

export interface IReleaseNoteContent {
  audience: ReleaseNoteAudience;
  language: ReleaseNoteLanguage;
  title: string;
  body: string;
}

export interface IReleaseNoteAudienceState {
  audience: ReleaseNoteAudience;
  status: ReleaseNotePublishStatus;
  publishedAt?: string;
}

export interface IReleaseNotePublishBlocker {
  audience: ReleaseNoteAudience;
  language: ReleaseNoteLanguage;
  missing: ("title" | "body")[];
}

export interface IReleaseNote {
  _id: string;
  releaseDate: string;
  versions: string[];
  content: IReleaseNoteContent[];
  audienceStates: IReleaseNoteAudienceState[];
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ICreateReleaseNotePayload {
  releaseDate: string;
  versions?: string[];
  content?: IReleaseNoteContent[];
}

export interface IUpdateReleaseNotePayload {
  releaseDate?: string;
  versions?: string[];
  content?: IReleaseNoteContent[];
}

export interface ITranslateReleaseNotePayload {
  audience: ReleaseNoteAudience;
  sourceLanguage: ReleaseNoteLanguage;
  targetLanguages: ReleaseNoteLanguage[];
}

export interface IReleaseNoteEmailPreview {
  subject: string;
  html: string;
}

export interface IMediaUploadTarget {
  uploadUrl: string;
  publicUrl: string;
  key: string;
}

export enum ReleaseNoteMerchantRole {
  Employee = "USER",
  Admin = "ADMIN",
  Owner = "ROOT",
}

export enum MerchantShareMode {
  Resolve = "resolve",
  Manual = "manual",
}

export interface IShareReleaseNotePayload {
  email?: {
    partners?: { recipients: string[]; language: ReleaseNoteLanguage };
    merchants?: {
      mode: MerchantShareMode;
      locales: ReleaseNoteLanguage[];
      roles?: ReleaseNoteMerchantRole[];
      recipients?: string[];
    };
  };
  slack?: {
    audience: ReleaseNoteAudience;
    language: ReleaseNoteLanguage;
  };
}

export interface IShareReleaseNoteResult {
  partners?: { sent: number };
  merchants?: Array<{ locale: string; sent: number }>;
  slack?: { posted: boolean };
  errors: string[];
}
